const ProposalDirectMarketingMethodEnum = Object.freeze({
    EMAIL: 'EMAIL',
    POST: 'POST',
    POST_DOCUMENTS: 'POST_DOCUMENTS'
});

export default ProposalDirectMarketingMethodEnum;
